import { type StorageInterface } from 'core/infra/storage/StorageInterface'

import sentry from 'legacy/utils/sentry'

import { SG_STORAGE_TOKEN_KEY, SG_AGNOSTIC_USER_KEY, type AgnosticUser } from '../domain/User'
import { type UserRepository } from './userRepository'

type AgnosticUserRepositoryDeps = {
  storage: StorageInterface
}

export class AgnosticUserRepository implements UserRepository {
  private storage: StorageInterface

  constructor({ storage }: AgnosticUserRepositoryDeps) {
    this.storage = storage
  }

  getLocalToken() {
    try {
      return this.storage.get<string>(SG_STORAGE_TOKEN_KEY)
    } catch (error) {
      sentry.log(error)
    }
  }

  setLocalToken(token: string) {
    this.storage.set(SG_STORAGE_TOKEN_KEY, token)
  }

  getAgnosticUser() {
    try {
      return this.storage.get<string>(SG_AGNOSTIC_USER_KEY)
    } catch (error) {
      sentry.log(error)
    }
  }

  setAgnosticUser(user: AgnosticUser) {
    this.storage.set(SG_AGNOSTIC_USER_KEY, user)
  }
}
